<template>
    <div class="bg-white rounded shadow-md">
       <div class="px-5 pt-8 pb-3">
           <div class="flex justify-between">
               <div class="text-20 font-medium">ข้อมูลส่วนตัว</div>
               <div class="border border-green-1 rounded-full px-4">
                   <button class="text-22 flex justify-center items-center text-green-1 font-medium" @click="editProfile()">แก้ไข</button>
               </div>
           </div>
           <div class="mt-1">
                <ProfileItem
                :detail="displayName"
                >
                    <img src="@/assets/icon/ic-user-green.svg" alt="">
                </ProfileItem>
                <ProfileItem
                :detail="formData.email"
                >
                    <img src="@/assets/icon/ic-mail-green.svg" alt="">
                </ProfileItem>
                <ProfileItem
                :detail="formData.contactNumber"
                >
                    <img src="@/assets/icon/ic-phone-green.svg" alt="">
                </ProfileItem>
                <ProfileItem
                :detail="formData.idcard"
                IsThaiID
                >
                    <img src="@/assets/icon/ic-card-green.svg" alt="">
                </ProfileItem>
                <ProfileItem
                :detail="displayGender()"
                >
                    <img src="@/assets/icon/ic-gender-green.svg" alt="">
                </ProfileItem>
                <ProfileItem
                :detail="displayBirthDate"
                >
                    <img src="@/assets/icon/ic-birth-green.svg" alt="">
                </ProfileItem>
                <ProfileItem
                :detail="displayAddress"
                >
                    <img src="@/assets/icon/ic-map-pin-green.svg" alt="">
                </ProfileItem>
            </div>
       </div>
    </div>
</template>

<script>
import ProfileItem from "./ProfileItem.vue";
import Util from "@/helper/Utility.js";
// helper
import DatetimeHelper from "@/helper/DatetimeHelper";
export default {
    name: "FormShowProfile",
    props: {
        setFormData: Object,
    },
    data: function() {
        return {
            formData: null,
        }
    },
    components: {
        ProfileItem,
    },
    computed: {
        displayName: function() {
            return this.formData.firstName + ' ' + this.formData.lastName;
        },
        displayAddress: function() {
            let addresstxt = this.formData.number ? this.formData.number : '';
            addresstxt = addresstxt += this.formData.soi ? ' ซอย ' + this.formData.soi: '';
            addresstxt = addresstxt += this.formData.road ? ' ถนน ' + this.formData.road: '';
            return addresstxt  + ' ' + this.formData.subDistrictName + ' ' + this.formData.districtName + ' ' + this.formData.provinceName + ' ' +this.formData.zipcode;
        },
        displayBirthDate: function() {
            if (this.formData.birthDate == null) return ''
            return DatetimeHelper.dateFullFormatBirthDate(this.formData.birthDate);
        },
    },
    created: function() {
        Util.log("form data", this.setFormData);
        this.formData = this.setFormData;

    },
    methods: {
        displayGender: function () {
            let gender = '';
            switch (this.formData.gender) {
                case 'male':
                    gender = 'ชาย'
                    break;
                case 'female':
                    gender = 'หญิง'
                    break;

                default:
                    gender = '';
                    break;
            }
            return gender;
        },
        editProfile: function() {
            this.tracking.event('profile', 'click_edit');

            this.$router.push('/editProfile');
        }
    },
}
</script>
